<template>
    <div style="position:relative;">
        <img
            style=" width: 100%; object-fit: cover; border-radius: 8px; height: 500px; object-position: top"
            :src="isTablet ? '/media/bg-20-10-mobile.jpg' : '/media/bg-20-10.jpg'" alt=""
        >
        <div class="message" style="margin-top: 50px">
            <div>{{ message }}</div>
            <span style="font-size: 13px">{{ sender }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessageView",
    data() {
        return {
            isTablet: window.innerWidth <= 820,
        }
    },
    props: {
        message: {
            type: String,
            required: true,
            default: ''
        },
        sender: {
            type: String,
            required: true,
            default: ''
        }
    }
}
</script>

<style scoped>
.message {
    overflow-y: auto;
    font-style: italic;
    color: white;
    font-size: 17px;
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    height: 260px;
    width: 100%;
    padding: 10px 50px;
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
    word-break: break-word;
}

@media (max-width: 1023px) {
    .message {
        font-size: 13px;
        margin: 0;
        padding: 10px;
    }
}
</style>
